export default __webpack_public_path__ + "static/Plots0001-1dd76b79f5479cc5f8affd6cbc78fce5.jpg";